import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { errorSelector } from '@rexmas/rexmas-shared/lib/redux/selectors/errors';
import { dismissError } from '@rexmas/rexmas-shared/lib/redux/actions/errors';
import { SnackbarCustom } from '@rexmas/rexmas-shared/lib/components/molecules/snackbars';
import { useSimpleState } from '@rexmas/rexmas-shared/lib/utils/hooks';
import Cookies from 'js-cookie';

function MessageBoundary({ error, children, deleteError }) {
  const [state, setState] = useSimpleState({
    showSnack: false,
    message: '',
    variant: 'info',
  });

  let djangoMessage = '';
  if (Cookies.get('messages')) {
    djangoMessage = Cookies.get('messages')
      .replace(/\\054/g, ',')
      .replace(/\\"/g, '"')
      .replace(/\\\\/g, '\\');
  }

  useEffect(() => {
    if (djangoMessage) {
      const { message: displayMessage, type } = JSON.parse(djangoMessage);
      setState({
        message: displayMessage,
        variant: type,
        showSnack: !!djangoMessage,
      });
      Cookies.remove('messages');
    }
  }, []);

  useEffect(() => {
    const hasMessage = error.hasError;
    if (hasMessage) {
      setState({
        message: error.user.message,
        variant: 'error',
        showSnack: error.hasError,
      });
      deleteError();
    }
  }, [error]);

  const handleClose = (_, reason) => {
    if (reason === 'timeout') setState({ showSnack: false });
  };

  const { message, variant, showSnack } = state;

  return (
    <>
      {children}

      <SnackbarCustom
        open={!!(showSnack)}
        variant={variant}
        onClose={handleClose}
      >
        <span>{message}</span>
      </SnackbarCustom>
    </>
  );
}

MessageBoundary.propTypes = {
  children: PropTypes.object.isRequired,
  error: PropTypes.object.isRequired,
  deleteError: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  error: errorSelector(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  deleteError: dismissError,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MessageBoundary);
